import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllPartStocks = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/part-stocks',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const savePartStock = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/part-stocks',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updatePartStock = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/part-stocks/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deletePartStock = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/part-stocks/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllPartStocks,
  savePartStock,
  deletePartStock,
  updatePartStock,
}
